import {
  AgentIncomeStatus,
  AgentIncomeType,
  AgentSumTransactionsResponse,
  AgentTransactionsType,
  EarningExplanationResponse,
  IncomeStatus,
  IncomeType,
  NewTransactionItem,
  NewTransactionResponse,
  SumTransactionResponse,
  SumTransactionVDriveResponse,
  SumTransactionVGrubsResponse,
  TransactionsFromDwollaResponse,
} from '../types/api/wallet.types';
import { WalletBankResponse } from '../types/partner';
import {
  DateRangeParams,
  PaginationParams,
  ResponseType,
} from '../types/shared.types';
import {
  AddBankV2Dto,
  CustomerEntity,
  TransactionPending,
  TransactionType,
  WalletReportType,
} from '../types/wallet.types';
import { api } from './api';

export const getAllCustomers = (params: PaginationParams) =>
  api.get<ResponseType<Array<CustomerEntity>>>(`/v1/wallet/customers`, {
    params,
  });

export const getAllTransactionFromDwolla = (
  params: PaginationParams &
    DateRangeParams<{
      customerId?: string;
    }>
) =>
  api.get<ResponseType<Array<TransactionsFromDwollaResponse>>>(
    `/v1/wallet/transactions-dwolla`,
    { params }
  );

export const getAllTransaction = (
  userId: string | number,
  params: PaginationParams &
    DateRangeParams<{
      type: TransactionType;
      incomeStatus?: IncomeStatus;
      incomeType?: IncomeType;
    }>
) =>
  api.get<ResponseType<Array<NewTransactionResponse>>>(
    `/v1/wallet/${userId}/new-transactions`,
    { params }
  );

export const getAllTransactionAgent = (
  agentId: string | number,
  params: PaginationParams &
    DateRangeParams<{
      type: AgentTransactionsType;
      incomeStatus?: AgentIncomeStatus[];
      incomeType?: AgentIncomeType;
      initialLimit?: number;
    }>
) =>
  api.get<ResponseType<Array<NewTransactionItem>>>(
    `/v1/wallet/${agentId}/new-transactions-agent`,
    { params }
  );

export const getSumTransactionAgent = (
  agentId: string | number,
  // `incomeStatus` mirrors the list param so the sum matches the rows shown.
  // The list takes an array (and knows `active`), the sum a single value.
  params: DateRangeParams<{ incomeStatus?: IncomeStatus }>
) =>
  api.get<ResponseType<AgentSumTransactionsResponse>>(
    `/v1/wallet/${agentId}/sum-transactions-agent`,
    { params }
  );

// TODO: confirm endpoint once backend is implemented.
export const exportTransactionReportAgent = (
  agentId: string | number,
  params: DateRangeParams
) =>
  api.get<ResponseType<Array<string>>>(
    `/v1/wallet/${agentId}/export-report-agent`,
    { params }
  );

// AI-generated, slow (~3-8s on a cold order). Fetch only on user demand.
export const getEarningExplanation = (
  userId: string | number,
  orderId: string | number
) =>
  api.get<ResponseType<EarningExplanationResponse>>(
    `/v1/wallet/${userId}/earning-explanation/${orderId}`
  );

export const getSumTransaction = (
  userId: string | number,
  params: DateRangeParams<{ incomeStatus?: IncomeStatus }>
) =>
  api.get<ResponseType<SumTransactionResponse>>(
    `/v1/wallet/${userId}/sum-transactions`,
    { params }
  );

export const getSumTransactionVDrive = (
  userId: string | number,
  params: DateRangeParams
) =>
  api.get<ResponseType<SumTransactionVDriveResponse>>(
    `/v1/wallet/${userId}/sum-transactions-vdrive`,
    { params }
  );
export const getSumTransactionVGrubs = (
  userId: string | number,
  params: DateRangeParams<{ incomeStatus?: IncomeStatus }>
) =>
  api.get<ResponseType<SumTransactionVGrubsResponse>>(
    `/v1/wallet/${userId}/sum-transactions-vgrubs`,
    { params }
  );

export const exportTransactionReport = (
  userId: string | number,
  params: DateRangeParams<{
    type?: WalletReportType;
    locationIds?: Array<number>;
  }>
) =>
  api.get<ResponseType<Array<string>>>(`/v1/wallet/${userId}/export-report`, {
    params,
  });

//   QUESTIONABLE
export const getTransactionTestReport = (
  userId: string | number,
  params: DateRangeParams
) =>
  api.get<ResponseType<null>>(`/v1/wallet/${userId}/test-report`, { params });

export const addBankAccountV2 = (data: AddBankV2Dto) =>
  api.post<ResponseType<WalletBankResponse>>(`/v2/wallet`, data);

export const editBankAccountV2 = (data: AddBankV2Dto) =>
  api.put<ResponseType<WalletBankResponse>>(`/v2/wallet`, data);

export const getTransactionPendingPartner = (locationId: string | number) =>
  api.get<ResponseType<Array<TransactionPending>>>(
    `/v1/wallet/pending-transactions`,
    {
      params: {
        locationId,
      },
    }
  );
